<template>
  <section class="wedding-section" ref="root">
    <p class="top-text" ref="topRef">¡NOS CASAMOS!</p>

    <div class="names-date">
      <div class="names" ref="namesRef">
        Eliezer<br /><br />
        &<br /><br />
        Heymi
      </div>

      <div class="date" ref="dateRef">
        <span>02</span>
        <span>Mayo</span>
        <span>2026</span>
      </div>
    </div>

    <p class="message" ref="msgRef">
      Nuestro amor nos ha llevado a este hermoso momento y con alegría les
      invitamos a compartir este paso tan especial en nuestras vidas.
    </p>

    <!-- ARCO -->
    <div class="arc-wrapper" ref="arcRef">
      <img src="@/assets/Gemini_Generated_Image_ck188hck188hck18.png" alt="Momento" />
    </div>
  </section>
</template>

<script>
import { gsap } from 'gsap'
import { onMounted, ref } from 'vue'

export default {
  name: 'WeddingMoment',
  setup() {
    const root = ref(null)
    const topRef = ref(null)
    const namesRef = ref(null)
    const dateRef = ref(null)
    const msgRef = ref(null)
    const arcRef = ref(null)

    onMounted(() => {
      // 🔹 Estados iniciales
      gsap.set([topRef.value, namesRef.value, msgRef.value, arcRef.value], {
        opacity: 0,
        y: 20
      })

      // 🔹 Números ocultos
      gsap.set(dateRef.value.querySelectorAll('span'), {
        opacity: 0,
        y: 20
      })

      // 🔹 Línea NO visible al inicio
      gsap.set(dateRef.value, {
        opacity: 0,
        scaleY: 0,
        transformOrigin: 'top center'
      })

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              gsap.delayedCall(0.35, () => {
                const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

                tl.to(topRef.value, {
                  opacity: 1,
                  y: 0,
                  duration: 0.7
                })

                tl.to(namesRef.value, {
                  opacity: 1,
                  y: 0,
                  duration: 1
                }, '-=0.3')

                // ✨ Línea aparece suave y elegante
                tl.to(dateRef.value, {
                  opacity: 1,
                  scaleY: 1,
                  duration: 0.6
                }, '-=0.4')

                // 🔹 Números aparecen después
                tl.to(dateRef.value.querySelectorAll('span'), {
                  opacity: 1,
                  y: 0,
                  stagger: 0.18,
                  duration: 0.7
                }, '-=0.3')

                tl.to(msgRef.value, {
                  opacity: 1,
                  y: 0,
                  duration: 0.9
                }, '-=0.4')

                tl.fromTo(
                  arcRef.value,
                  { scaleY: 0.92, transformOrigin: 'bottom center' },
                  {
                    opacity: 1,
                    scaleY: 1,
                    duration: 1.4,
                    ease: 'power2.out'
                  },
                  '-=0.3'
                )
              })

              obs.unobserve(entry.target)
            }
          })
        },
        {
          threshold: 0.4,
          rootMargin: '0px 0px -10% 0px'
        }
      )

      observer.observe(root.value)
    })

    return {
      root,
      topRef,
      namesRef,
      dateRef,
      msgRef,
      arcRef
    }
  }
}
</script>

<style scoped>
.wedding-section {
  background-color: rgba(217, 212, 209, 0.95);
  padding-top: 56px;
  text-align: center;
  margin-bottom: 40px;
  color: #000;
}

.top-text {
  font-family: 'save', cursive;
  font-size: 22px;
  letter-spacing: 2px;
  font-weight: 600;
  margin-bottom: 28px;
}

.names-date {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 28px;
}

.names {
  font-family: 'cursiva', cursive;
  font-size: 36px;
  line-height: 1.05;
}

.date {
  font-family: 'save', cursive;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 14px;
  border-left: 2px solid #000;
  font-size: 36px;
}

.message {
  font-family: 'padres', cursive;
  font-weight: 600;
  max-width: 340px;
  margin: 26px auto 34px;
  font-size: 14px;
  line-height: 1.6;
}

.arc-wrapper {
  width: 100%;
  margin-bottom: 40px;
  height: 58vh;
  overflow: hidden;
  border-top-left-radius: 100% 100%;
  border-top-right-radius: 100% 100%;
}

.arc-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
